import { createContext, createElement, useContext, useReducer } from 'react';
import type { Mutation } from './mutations';
import type { State } from './types';
import { reducer } from './mutations';

export interface MilestonesStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const initialState: State = {
  list: [],
  loaded: false,
};

export const MilestonesContext = createContext<MilestonesStore>({
  state: initialState,
} as MilestonesStore);

export function MilestonesStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return createElement(
    MilestonesContext.Provider,
    { value: { state, dispatch } },
    children,
  );
}

export function useMilestonesStore() {
  return useContext(MilestonesContext);
}
